import {
  ConfluenceSourceParametersLoadingMode,
  FileConversionFormat,
  FileConverterEngine,
  IngestionSourceParametersOutput,
  IngestionSourceParametersType,
  WebsiteSourceParametersReceivingMode,
} from '../../../../../../gamma-api';
import { generateExternalId } from '../../utils';
import { DEFAULT_ELMA365_FILTRATION_JSON } from '../SourceSettings/ELMA365AppFieldsSelector/utils';

import { CONFLUENCE_DEFAULT_CONTENT_SELECTOR, CONFLUENCE_DEFAULT_FILTER_SELECTOR } from './const';

export const createParametersForType = (type: IngestionSourceParametersType): IngestionSourceParametersOutput => {
  switch (type) {
    case IngestionSourceParametersType.Website:
      return {
        external_id: generateExternalId(),
        type: IngestionSourceParametersType.Website,
        name: '',
        settings: {
          source_type: IngestionSourceParametersType.Website,
          base_url: '',
          extra_urls: [],
          receiving_mode: WebsiteSourceParametersReceivingMode.Crawler,
        },
        extraction: {
          file: {},
          html: {
            content_selector: '',
            filter_selector: '',
          },
          text: {},
        },
      };
    case IngestionSourceParametersType.File:
      return {
        external_id: generateExternalId(),
        type: IngestionSourceParametersType.File,
        name: '',
        settings: {
          source_type: IngestionSourceParametersType.File,
          files: [],
        },
        extraction: {
          file: {
            converter_engine: FileConverterEngine.Markitdown,
            conversion_format: FileConversionFormat.Markdown,
          },
          html: {},
          text: {},
        },
      };
    case IngestionSourceParametersType.Elma365:
      return {
        external_id: generateExternalId(),
        type: IngestionSourceParametersType.Elma365,
        name: '',
        settings: {
          source_type: IngestionSourceParametersType.Elma365,
          connector_id: '',
          filtration_enabled: false,
          filtration_json: DEFAULT_ELMA365_FILTRATION_JSON,
          feed: {
            enabled: false,
          },
          status: {
            refresh_enabled: false,
            selected_item_ids: [],
          },
        },
        extraction: {
          file: {},
          html: {},
          text: {},
        },
      };
    case IngestionSourceParametersType.Confluence:
    default:
      return {
        external_id: generateExternalId(),
        type: IngestionSourceParametersType.Confluence,
        name: '',
        settings: {
          source_type: IngestionSourceParametersType.Confluence,
          base_url: '',
          loading_mode: ConfluenceSourceParametersLoadingMode.Pages,
        },
        extraction: {
          file: {},
          html: {
            content_selector: CONFLUENCE_DEFAULT_CONTENT_SELECTOR,
            filter_selector: CONFLUENCE_DEFAULT_FILTER_SELECTOR,
          },
          text: {},
        },
      };
  }
};
